export const PDPBestOfferSkeleton = [
    {
        columns: [{ span: 8, height: "48px", classes: "marginTop-16" }],
    },
    {
        columns: [{ span: 8, height: "60px", classes: "marginTop-16" }],
    },
    {
        columns: [{ span: 8, height: "48px", classes: "marginTop-16" }],
    },
]
